module.exports = __webpack_public_path__ + "media/images/levante_infinity-09f463437c49a968897965eb22126dc4.png";